import React from 'react';

import { Box } from '@mui/material';

import PageSubheader from '../Common/Elements/PageSubheader';

import GHAPriceAggregatedReports from './GHAPriceAggregatedReports';
import GHARawReportDownload from './GHARawReportDownload';

function GHAPriceReports() {
  return (
    <Box>
      <PageSubheader title="GHA Price Scrapper Reports" />
      <GHAPriceAggregatedReports />
      <PageSubheader title="GHA Price Report" />
      <Box mt={6}>
        <GHARawReportDownload />
      </Box>
    </Box>
  );
}

export default GHAPriceReports;
